import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import api from 'src/axios';

type UpdateProductForecastProps = {
  sessionId: string;
  sku: string;
  forecasts: {
    month: number;
    year: number;
    validated_forecast: number;
  }[];
};

async function updateProductForecastRequest({
  sessionId,
  sku,
  forecasts,
}: UpdateProductForecastProps) {
  const { data } = await api.put(
    `/sales-forecasting-sessions/${sessionId}/products/${sku}/validate`,
    forecasts,
  );

  return data;
}

export const useUpdateProductForecast = (
  options?: Omit<
    UseMutationOptions<void, Error, UpdateProductForecastProps>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, UpdateProductForecastProps> => {
  return useMutation({
    mutationFn: updateProductForecastRequest,
    ...options,
  });
};
